import { getDistanceInMeters } from '@app/utils/geometry'

import type { Address } from '@app/packages/geo/Address'
import { MAP_AREA_KIND } from '@app/packages/geo/constants'

export function addressIsPreciseEnoughToSearch(address: Address) {
  if (!address.bounds || address.kind === MAP_AREA_KIND) return true
  const maxSize = Math.max(
    getDistanceInMeters([
      [address.bounds.bottomLeft.lat, address.bounds.bottomLeft.lon],
      [address.bounds.bottomLeft.lat, address.bounds.topRight.lon],
    ]),
    getDistanceInMeters([
      [address.bounds.bottomLeft.lat, address.bounds.bottomLeft.lon],
      [address.bounds.topRight.lat, address.bounds.bottomLeft.lon],
    ])
  )
  return maxSize <= 120 * 1000 // 120 km
}
